<ngx-heka-heka-navigation-container appTitle="{{'APPS.CUSTOMER_PORTAL.TITLE'|translate}}"
                                    appImageLink="{{'assets/images/heka-logo-symbols/hplus.svg'}}"
                                    startPage="/pages"
                                    collapseText="{{'MENU.COLLAPSE'|translate}}"
                                    [accountMenu]="accountMenu"
                                    [helpLink]="env.links.help"
                                    [loading]="(loadingService.getLoading().asObservable() |async)||false"
                                    (onDomainChange)="domainHandlerService.switchDomainAndReload($event.domainId)">
  <ngx-heka-no-app-access class="mx-auto" [title]="'OAUTH.NO_ACCESS.TITLE'|translate" [description]="description">
    <button mat-flat-button color="primary" (click)="authService.logout()">
      {{ 'OAUTH.LOGIN_BTN' | translate }}
    </button>
  </ngx-heka-no-app-access>
</ngx-heka-heka-navigation-container>
